export enum TranslationParam {

    name = "name",
    value = "value",
}
